import React from "react";
import "./actions.css";
import ComponentTitle from "../../Text/Title/Title";
import {
  Row,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Col,
  Button,
} from "reactstrap";
import useApiRequests from "../../../hooks/useApiRequests";
import { useNotification } from "../../../hooks/useNotification";
import { IMember } from "../../../interfaces/IMember";
import Divider from "@mui/material/Divider";

function Actions() {
  const {
    getBoardMembers,
    getAllMemberActions,
    updateAllMemberActions,
    calculateMemberActionsChange,
  } = useApiRequests();
  const { notify } = useNotification();

  const [devs, setDevs] = React.useState<IMember[] | null>(null);
  const [sups, setSups] = React.useState<IMember[] | null>(null);

  const [changePrManually, setChangePrManually] =
    React.useState<boolean>(false);

  //#region UseEffects

  React.useEffect(() => {
    getAllMembers();
  }, []);

  // React.useEffect(() => console.log("A", devs), [devs]);

  //#endregion

  //#region Logics

  async function getAllMembers() {
    const data = await getAllMemberActions();
    if (data.success) {
      console.log(data.data);
      // const devsList = data.data?.filter((element: any) => {
      //   return element.memberType != null && element.memberType.includes("Dev");
      // });
      // const supsList = data.data?.filter((element: any) => {
      //   return (
      //     element.memberType != null && element.memberType.includes("Suport")
      //   );
      // });

      // setDevs(devsList);
      // setSups(supsList);
    } else {
      notify("Ocorreu um erro ao buscar os dados", { type: "error" });
    }
  }

  //Essa é pra porcentagem de PR
  async function handlePercentageChange(index: number, newPercentage: string) {
    const updatedDevs = JSON.parse(JSON.stringify(devs));
    updatedDevs[index].ChangePrManualy = true;

    const data = await calculateMemberActionsChange(updatedDevs, "PR");
    if (data.success) {
      setDevs(data.data);
    }
  }

  //Essa é pra porcentagem de PR
  function handlePrPercentageChange(index: number, value: string) {
    const updatedDevs = JSON.parse(JSON.stringify(devs));
    updatedDevs[index].prPercentage = value;
    setDevs(updatedDevs);
  }

  //Essa é pra porcentagem de PR
  async function handleCheckboxChangeDevs(index: number, checked: boolean) {
    const devsCopy = JSON.parse(JSON.stringify(devs));
    devsCopy[index].canApprovePR = checked;

    if (checked == false) {
      devsCopy[index].prPercentage = "0";
      devsCopy[index].ChangePrManualy = false;
    }

    const data = await calculateMemberActionsChange(devsCopy, "PR");
    if (data.success) {
      setDevs(data.data);
    }
  }

  //Daqui pra baixo é pra Analysis <====================================================>
  async function handleAnalysisChange(index: number, newPercentage: string) {
    const updatedDevs = JSON.parse(JSON.stringify(devs));

    const data = await calculateMemberActionsChange(updatedDevs, "AN");
    if (data.success) {
      setDevs(data.data);
    }
  }

  function handleAnalysisPercentageChange(index: number, value: string) {
    const updatedDevs = JSON.parse(JSON.stringify(devs));
    updatedDevs[index].analysisPercentage = value;
    updatedDevs[index].changeAnalysisManualy = true;
    setDevs(updatedDevs);
  }

  async function handleCheckboxChangeDevsAnalysis(
    index: number,
    checked: boolean
  ) {
    const devsCopy = JSON.parse(JSON.stringify(devs));
    devsCopy[index].performAnalysis = checked;

    if (checked == false) {
      devsCopy[index].analysisPercentage = "0";
      devsCopy[index].changeAnalysisManualy = false;
    }

    const data = await calculateMemberActionsChange(devsCopy, "AN");
    if (data.success) {
      setDevs(data.data);
    }
  }

  //#endregion

  return (
    <div className="page-container" style={{ paddingBottom: "1rem" }}>
      <div className="d-flex flex-wrap justify-content-between">
        <div className="title-and-subtitle">
          <ComponentTitle>Ações</ComponentTitle>
        </div>
        <Button color="success" style={{ height: "48px" }}>
          Salvar
        </Button>
      </div>

      <Row className="d-flex align-items-center mt-5 justify-content-between">
        {/* <span className="divider"></span> */}
        <p className="gray-text-subtitle mt-3">Ações Desenvolvedores</p>
        <Card className="" style={{ padding: "1rem" }}>
          {devs != null &&
            devs != undefined &&
            devs?.map((element: any, index: any) => (
              <Row
                key={index}
                className="border d-flex align-items-center shadow-sm mb-1 bg-white rounded"
                style={{ padding: "1rem" }}
              >
                <Col md={2}>
                  <span className="theme-text-color">
                    {element.memberName.split(" ")[0]}
                  </span>
                </Col>
                <Col md={2}>
                  <FormGroup check inline>
                    <Input
                      type="checkbox"
                      checked={element.canApprovePR || false}
                      onChange={(e) =>
                        handleCheckboxChangeDevs(index, e.target.checked)
                      }
                    />
                    <Label check>Aprova PR's</Label>
                  </FormGroup>
                </Col>
                <>
                  <Col md={2}>
                    <Input
                      disabled={
                        !element.canApprovePR != null && !element.canApprovePR
                      }
                      type="text"
                      name="pr-percentage"
                      id="pr-percentage"
                      value={element.prPercentage}
                      onChange={(e) =>
                        handlePrPercentageChange(index, e.target.value)
                      }
                      onBlur={(e) => {
                        const newPercentage = e.target.value;
                        handlePercentageChange(index, newPercentage);
                      }}
                    />
                  </Col>
                </>

                <Col md={2}>
                  <FormGroup check inline>
                    <Input
                      type="checkbox"
                      checked={element.performAnalysis || false}
                      onChange={(e) =>
                        handleCheckboxChangeDevsAnalysis(
                          index,
                          e.target.checked
                        )
                      }
                    />
                    <Label check>Faz Análises</Label>
                  </FormGroup>
                </Col>
                <>
                  <Col md={2}>
                    <Input
                      disabled={
                        !element.performAnalysis != null &&
                        !element.performAnalysis
                      }
                      type="text"
                      name="pr-percentage"
                      id="pr-percentage"
                      value={element.analysisPercentage}
                      onChange={(e) =>
                        handleAnalysisPercentageChange(index, e.target.value)
                      }
                      onBlur={(e) => {
                        const newPercentage = e.target.value;
                        handleAnalysisChange(index, newPercentage);
                      }}
                    />
                  </Col>
                </>
              </Row>
            ))}
        </Card>
      </Row>
    </div>
  );
}

export default Actions;
